export default "__VITE_PUBLIC_ASSET__624fec14__"